import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchMarketingPersonBusinessReport = (filter) => {
  const { zone_id, date_from, date_to } = filter;

  return axiosInstance.post(EndPoints.MARKETING_PERSON_BUSINESS_REPORT.LIST, {
    data: {
      date_from,
      date_to,
    },
    query_params: {
      zone_id: zoneLocalStorageId(),
    },
  });
};

export const fetchMarketingPersonBusinessReportDetail = (filter) => {
  const { date_from, date_to, employee_code_id, is_active, page_no, limit } =
    filter;

  return axiosInstance.post(EndPoints.MARKETING_PERSON_BUSINESS_REPORT.DETAIL, {
    data: {
      date_from,
      date_to,
      employee_code_id,
      is_active,
      page_no,
      limit,
      total_count: 0,
    },
    query_params: {
      zone_id: zoneLocalStorageId(),
    },
  });
};
